<template>
    <div class="rounded-md p-4" :class="danger ? 'bg-red-50' : 'bg-blue-50'">
        <div class="flex">
            <div class="flex-shrink-0">
                <!-- Heroicon name: solid/information-circle -->
                <svg v-if="danger" class="h-5 w-5 text-red-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" />
                </svg>
                <svg v-else class="h-5 w-5 text-blue-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd" />
                </svg>
            </div>
            <div class="ml-3">
                <h3 v-if="title" class="text-sm font-medium" :class="danger ? 'text-red-800' : 'text-blue-800'">{{ title }}</h3>
                <div class="mt-2 text-sm" :class="danger ? 'text-red-700' : 'text-blue-700'">
                    <slot></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        danger: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: null,
        },
    }
}
</script>
